export function MyLink(props: any) {
    return <a onClick={props.callback}
              style={{ textDecoration: "underline", cursor: "pointer", color: "#94b6f9" }}>{props.label}</a>
}